<!-- <div class="ms-CommandBar">
  <div class="ms-CommandBar-sideCommands">
    <button
      type="button"
      class="ms-CommandButton-button"
    >
      <span class="ms-CommandButton-icon"
        ><i class="ms-Icon ms-Icon--ShieldAlert"></i
      ></span>
      <span class="ms-CommandButton-label">ssss</span>
    
    </button>
    <button
      type="button"
      class="ms-CommandButton-button"
    >
      <span class="ms-CommandButton-label">zzzz</span>
    </button>
    <button
      type="button"
      class="ms-CommandButton-button"
    >
      <span class="ms-CommandButton-icon"
        ><i class="ms-Icon ms-Icon--FollowUser"></i
      ></span>
      <span class="ms-CommandButton-label">NOmbre</span>
    </button>
    <button
      type="button"
      class="ms-CommandButton-button"
    >
      <span class="ms-CommandButton-icon"
        ><i class="ms-Icon ms-Icon--SignOut"></i
      ></span>
      <span class="ms-CommandButton-label">logout</span>
    </button>
  </div>
  <div class="ms-CommandBar-mainArea"></div>
</div>


 -->


 <fluent-tabs activeid="entrees" class="fluent-menu">
  <fluent-tab id="apps" (click)="toggleTab('apps')" class="fluent-menu-item">
    <fluent-icon icon="FileDocument" class="fluent-icon"></fluent-icon>
    <span class="fluent-menu-text">Archivo</span>
  </fluent-tab>
  <fluent-tab id="export" (click)="toggleTab('export')" class="fluent-menu-item">
    <fluent-icon icon="Download" class="fluent-icon"></fluent-icon>
    <span class="fluent-menu-text">Exportar</span>
  </fluent-tab>

  <fluent-tab-panel id="apps">
    <ol>
      <fluent-menu *ngIf="archivoTabActivo === 'apps'" class="fluent-menu-dropdown">
        <fluent-menu-item (click)="openFileInput()">
          <fluent-icon icon="Import" class="fluent-icon"></fluent-icon>
          <span class="fluent-menu-text">Importar</span>
        </fluent-menu-item>
        <input type="file" #fileInput style="display:none" (change)="onFileSelected($event)">

        <fluent-divider></fluent-divider>
      </fluent-menu>
    </ol>
  </fluent-tab-panel>

  <fluent-tab-panel id="export">
    <ol>
      <fluent-menu *ngIf="archivoTabActivo === 'export'" class="fluent-menu-dropdown">
        <fluent-option class="fluent-menu-item">
          <fluent-icon icon="ExportVariant" class="fluent-icon"></fluent-icon>
          <a (click)="activateExportArtifacts()"   #downloadSvgLinkRef id="js-download-svg"   class="fluent-menu-link">Exportar SVG</a>
        </fluent-option>
        <br>

        <fluent-option class="fluent-menu-item">
          <fluent-icon icon="ExportVariant" class="fluent-icon"></fluent-icon>
          <a (click)="activateExportArtifacts()"   #downloadLinkRef id="js-download-diagram"  class="fluent-menu-link">Exportar BPMN</a>  
        </fluent-option>
      </fluent-menu>
    </ol>
  </fluent-tab-panel>
</fluent-tabs>